(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dispo-mosaic"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__tpRevealReady) return;
    window.__tpRevealReady = true;
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    function arm() {
      document.querySelectorAll('.reveal:not(.is-visible)').forEach(function (el) { obs.observe(el); });
    }
    arm();
    document.addEventListener('shopify:section:load', arm);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flavor-cta"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__tpFlavorsBound) return;
    window.__tpFlavorsBound = true;

    var toast = document.getElementById('tp-toast');
    var toastMsg = document.getElementById('tp-toast-msg');
    var toastCount = document.getElementById('tp-toast-count');
    var toastTimer;

    function showToast(productTitle, cartCount, isSub) {
      if (!toast) return;
      toastMsg.textContent = (productTitle || 'Item') + (isSub ? ' (monthly)' : '') + ' added to cart';
      toastCount.textContent = cartCount + ' in cart';
      toast.style.opacity = '1';
      toast.style.transform = 'translateX(-50%) translateY(0)';
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () {
        toast.style.opacity = '0';
        toast.style.transform = 'translateX(-50%) translateY(120%)';
      }, 3000);
    }

    function triggerHorizonCart(cart) {
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { data: { itemCount: cart.item_count, source: 'product-form-component' } }
      }));
      var cartDrawer = document.querySelector('cart-drawer-component');
      if (cartDrawer && typeof cartDrawer.open === 'function') cartDrawer.open();
      var badges = document.querySelectorAll('[data-cart-count], .cart-count, .header-cart-count');
      badges.forEach(function(badge) {
        badge.textContent = cart.item_count;
        if (cart.item_count > 0) badge.classList.add('is-visible');
      });
    }

    function fmtPrice(cents) { return '$' + (cents / 100).toFixed(2); }

    function refreshPanel(panel) {
      var sub = panel.getAttribute('data-tp-sub') === '1';
      var qty = parseInt(panel.getAttribute('data-tp-qty-state') || '1', 10);
      var otoPrice = parseInt(panel.getAttribute('data-tp-oto-price'), 10);
      var subPrice = parseInt(panel.getAttribute('data-tp-sub-price'), 10);
      var unit = sub ? subPrice : otoPrice;

      var priceEl = panel.querySelector('[data-tp-price]');
      var strikeEl = panel.querySelector('[data-tp-strike]');
      var qtyEl = panel.querySelector('[data-tp-qty-value]');
      var subSub = panel.querySelector('[data-tp-sub-sub]');
      var toggle = panel.querySelector('[data-tp-sub-toggle]');

      if (qtyEl) qtyEl.textContent = String(qty);
      if (priceEl) priceEl.innerHTML = fmtPrice(unit * qty) + '<span>/pack</span>';
      if (strikeEl) {
        if (sub) { strikeEl.style.display = ''; strikeEl.textContent = fmtPrice(otoPrice * qty); }
        else { strikeEl.style.display = 'none'; }
      }
      if (subSub) subSub.textContent = sub ? 'Delivered monthly · cancel anytime' : 'One-time purchase';
      if (toggle) {
        toggle.classList.toggle('is-on', sub);
        toggle.setAttribute('aria-pressed', sub ? 'true' : 'false');
      }
    }

    function initPanel(panel) {
      if (panel.__tpReady) return;
      panel.__tpReady = true;
      panel.setAttribute('data-tp-sub', '1');
      panel.setAttribute('data-tp-qty-state', '1');
      refreshPanel(panel);
    }

    document.querySelectorAll('[data-tp-flavor]').forEach(initPanel);
    document.addEventListener('shopify:section:load', function () {
      document.querySelectorAll('[data-tp-flavor]').forEach(initPanel);
      centerCarousel();
    });

    /* ── Mobile carousel: center the middle panel + sync swipe dots ── */
    function syncSwipeDots() {
      var container = document.querySelector('.flavors-cta');
      var dots = document.querySelectorAll('.flavors-swipe-dot');
      if (!container || !dots.length) return;
      var panels = container.querySelectorAll('.flavor-panel');
      var center = container.scrollLeft + container.clientWidth / 2;
      var activeIdx = 0;
      var best = Infinity;
      panels.forEach(function (p, i) {
        var pc = p.offsetLeft + p.clientWidth / 2;
        var dist = Math.abs(pc - center);
        if (dist < best) { best = dist; activeIdx = i; }
      });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === activeIdx); });
    }

    function centerCarousel() {
      var container = document.querySelector('.flavors-cta');
      if (!container) return;
      if (window.innerWidth > 740) { container.scrollLeft = 0; return; }
      var panels = container.querySelectorAll('.flavor-panel');
      if (panels.length < 2) return;
      var mid = panels[Math.floor(panels.length / 2)];
      var target = mid.offsetLeft - (container.clientWidth - mid.clientWidth) / 2;
      container.scrollLeft = Math.max(0, target);
      syncSwipeDots();
    }

    var flavorsScroller = document.querySelector('.flavors-cta');
    if (flavorsScroller) {
      flavorsScroller.addEventListener('scroll', function () {
        window.requestAnimationFrame(syncSwipeDots);
      }, { passive: true });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', centerCarousel);
    } else {
      centerCarousel();
    }
    window.addEventListener('resize', centerCarousel);
    setTimeout(centerCarousel, 300);

    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-tp-sub-toggle]');
      if (toggle) {
        var panel = toggle.closest('[data-tp-flavor]');
        var cur = panel.getAttribute('data-tp-sub') === '1';
        panel.setAttribute('data-tp-sub', cur ? '0' : '1');
        refreshPanel(panel);
        return;
      }

      var qtyBtn = e.target.closest('[data-tp-qty]');
      if (qtyBtn) {
        var panel2 = qtyBtn.closest('[data-tp-flavor]');
        var delta = parseInt(qtyBtn.getAttribute('data-tp-qty'), 10);
        var cur2 = parseInt(panel2.getAttribute('data-tp-qty-state'), 10) || 1;
        var next = Math.max(1, Math.min(12, cur2 + delta));
        panel2.setAttribute('data-tp-qty-state', String(next));
        refreshPanel(panel2);
        return;
      }

      var addBtn = e.target.closest('[data-tp-flavor-add]');
      if (addBtn) {
        var panel3 = addBtn.closest('[data-tp-flavor]');
        var sub = panel3.getAttribute('data-tp-sub') === '1';
        var qty = parseInt(panel3.getAttribute('data-tp-qty-state'), 10) || 1;
        var id = parseInt(panel3.getAttribute('data-tp-otoid'), 10);
        if (!id) return;

        var cartItem = { id: id, quantity: qty };
        if (sub) {
          var sellingPlan = parseInt(panel3.getAttribute('data-tp-selling-plan'), 10);
          if (sellingPlan) cartItem.selling_plan = sellingPlan;
        }

        addBtn.disabled = true;
        addBtn.style.opacity = '0.7';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [cartItem] })
        })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            addBtn.disabled = false;
            addBtn.style.opacity = '';
            if (data.status) { console.error('Cart error:', data); window.location.href = '/cart'; return; }
            document.dispatchEvent(new CustomEvent('tp:cart-updated', { detail: data }));
            var burst = panel3.querySelector('[data-tp-burst]');
            if (burst) {
              burst.hidden = false;
              clearTimeout(panel3.__tpBurstT);
              panel3.__tpBurstT = setTimeout(function () { burst.hidden = true; }, 1400);
            }
            fetch('/cart.js')
              .then(function(r) { return r.json(); })
              .then(function(cart) {
                triggerHorizonCart(cart);
                var productTitle = data.items && data.items[0] ? data.items[0].product_title : null;
                showToast(productTitle, cart.item_count, sub);
              });
          })
          .catch(function () {
            addBtn.disabled = false;
            addBtn.style.opacity = '';
            window.location.href = '/cart';
          });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredients"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* ── Reveal observer ── */
    if (!window.__tpRevealReady) {
      window.__tpRevealReady = true;
      if (!('IntersectionObserver' in window)) {
        document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-visible'); });
      } else {
        var obs = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) { entry.target.classList.add('is-visible'); obs.unobserve(entry.target); }
          });
        }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
        function arm() { document.querySelectorAll('.reveal:not(.is-visible)').forEach(function (el) { obs.observe(el); }); }
        arm();
        document.addEventListener('shopify:section:load', arm);
      }
    }

    /* ── Accordion (mobile only) ── */
    function initAccordion() {
      document.querySelectorAll('[data-ing-toggle]').forEach(function (toggle) {
        if (toggle.__tpAccordion) return;
        toggle.__tpAccordion = true;
        toggle.style.cursor = 'pointer';
        toggle.addEventListener('click', function () {
          if (window.innerWidth > 760) return;
          var card = toggle.closest('[data-ing-card]');
          var isOpen = card.classList.contains('is-open');
          document.querySelectorAll('[data-ing-card].is-open').forEach(function (c) { c.classList.remove('is-open'); });
          if (!isOpen) card.classList.add('is-open');
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAccordion);
    } else {
      initAccordion();
    }
    document.addEventListener('shopify:section:load', initAccordion);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["story"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__tpRevealReady) return;
    window.__tpRevealReady = true;
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    function arm() {
      document.querySelectorAll('.reveal:not(.is-visible)').forEach(function (el) { obs.observe(el); });
    }
    arm();
    document.addEventListener('shopify:section:load', arm);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tp-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__tpHeroBound) return;
    window.__tpHeroBound = true;
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["urgency"] && !Shopify.designMode) return;
  try {
    
  // Reveal + stat counter. Shared globals are guarded so duplicate sections
  // (and other TIDEPOOL sections that ship the same observer) don't double-bind.
  (function () {
    function ensureReveal() {
      if (window.__tpRevealReady) return;
      window.__tpRevealReady = true;
      if (!('IntersectionObserver' in window)) {
        document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-visible'); });
        return;
      }
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            obs.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
      function arm() {
        document.querySelectorAll('.reveal:not(.is-visible)').forEach(function (el) { obs.observe(el); });
      }
      arm();
      // Re-arm when sections are reloaded inside the theme editor.
      document.addEventListener('shopify:section:load', arm);
    }

    function animateStat(el) {
      if (el.__tpAnimated) return;
      el.__tpAnimated = true;
      var target = parseFloat(el.getAttribute('data-tp-stat-target')) || 0;
      var duration = parseFloat(el.getAttribute('data-tp-stat-duration')) || 1500;
      var start = null;
      function step(t) {
        if (!start) start = t;
        var p = Math.min((t - start) / duration, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(eased * target).toString();
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }

    function armStats() {
      if (!('IntersectionObserver' in window)) {
        document.querySelectorAll('[data-tp-stat-target]').forEach(animateStat);
        return;
      }
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            animateStat(e.target);
            obs.unobserve(e.target);
          }
        });
      }, { threshold: 0.4 });
      document.querySelectorAll('[data-tp-stat-target]').forEach(function (el) { obs.observe(el); });
    }

    function init() {
      ensureReveal();
      armStats();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', armStats);
  })();

  } catch(e) { console.error(e); }
})();
})();
